import { render, staticRenderFns } from "./SystemTypeDetail.vue?vue&type=template&id=74130c66&scoped=true"
import script from "./SystemTypeDetail.vue?vue&type=script&lang=js"
export * from "./SystemTypeDetail.vue?vue&type=script&lang=js"
import style0 from "./SystemTypeDetail.vue?vue&type=style&index=0&id=74130c66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74130c66",
  null
  
)

export default component.exports